import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import React from 'react';
import { createUseStyles } from 'react-jss';
import {
  primaryButtonStyle,
  buttonSizeMap,
  secondaryButtonStyle,
} from '../../constants/ButtonStyles';

const useStyles = createUseStyles({
  actions: {
    display: 'flex',
    justifyContent: 'center',
  },
  content: {
    marginBottom: 16,
    overflow: 'auto',
  },
  dialogPaper: {
    '@media (max-width: 768px)': {
      padding: 16,
      width: '95%',
    },
    maxHeight: '80%',
    maxWidth: '1000px',
    padding: 24,
    width: '80%',
  },
});
interface HandbookDialogProps {
  open: boolean;
  handbookContent: string;
  checked: boolean;
  onCheck: (checked: boolean) => void;
  onAccept: () => void;
  onCancel: () => void;
}

const HandbookDialog: React.FC<HandbookDialogProps> = ({
  open,
  handbookContent,
  checked,
  onCheck,
  onAccept,
  onCancel,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth={false}
      PaperProps={{
        className: classes.dialogPaper,
      }}
      aria-labelledby="handbook-dialog-title"
      onKeyDown={(e) => {
        if (e.key === 'Escape') onCancel();
      }}
    >
      <DialogContent>
        <div
          id="handbook-dialog-title"
          className={classes.content}
          dangerouslySetInnerHTML={{ __html: handbookContent || '' }}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={(e) => onCheck(e.target.checked)}
              name="handbook"
            />
          }
          label="I have read the document and acknowledge consent by checking the checkbox."
        />
      </DialogContent>

      <DialogActions className={classes.actions}>
        <>
          <Button
            onClick={onCancel}
            variant="outlined"
            startIcon={<CloseIcon />}
            sx={{
              ...secondaryButtonStyle,
              ...buttonSizeMap.medium,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={onAccept}
            disabled={!checked}
            variant="contained"
            autoFocus
            startIcon={<CheckCircleIcon />}
            sx={{
              ...primaryButtonStyle,
              ...buttonSizeMap.medium,
            }}
          >
            Accept
          </Button>
        </>
      </DialogActions>
    </Dialog>
  );
};

export default HandbookDialog;
